import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

/** Stripe redirects here after successful payment. Forward to the premium page with session_id so it can poll verification. */
export default function PremiumSuccessPage() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const eventId = sp.get('event_id') || '';
  const sessionId = sp.get('session_id') || '';

  useEffect(() => {
    const params = new URLSearchParams();
    if (eventId) params.set('event_id', eventId);
    if (sessionId) params.set('session_id', sessionId);
    navigate(`/host-premium?${params.toString()}`, { replace: true });
  }, [eventId, sessionId, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen" data-testid="premium-success-redirect">
      <div className="w-8 h-8 border-2 border-[#146BFF] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
